<template>
    <form
      id="registerForm"
      method="post"
      @click.prevent="validateBeforeSubmit"
    >
      <div class="row">
        <div class="col" style="padding:10px">
          <label class="form-label">{{ $t('login.enter_name') }}</label><span class="text-danger"> *</span>
          <base-input
            :invalid="$v.registerData.name.$error"
            v-model.trim="registerData.name"
            type="text"
            :placeholder="$t('login.enter_name')"
            name="name"
            @input="$v.registerData.name.$touch()"
          />
          <div v-if="$v.registerData.name.$error">
            <span v-if="!$v.registerData.name.required" class="text-danger">{{ $tc('validation.required') }}</span>
          </div>
        </div>

        <div class="col" style="padding:10px">
          <label class="form-label">{{ $t('login.enter_company') }}</label><span class="text-danger"> *</span>
          <base-input
            :invalid="$v.registerData.company.$error"
            v-model.trim="registerData.company"
            :placeholder="$t('login.enter_company')"
            type="text"
            name="company"
            @input="$v.registerData.company.$touch()"
          />
          <div v-if="$v.registerData.company.$error">
            <span v-if="!$v.registerData.company.required" class="text-danger">{{ $tc('validation.required') }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col" style="padding:10px">
          <label class="form-label">{{ $t('login.enter_website') }}</label>
          <base-input
            v-model.trim="registerData.website"
            :placeholder="$t('login.enter_website')"
            type="text"
            name="website"
          />
        </div>
        <div class="col" style="padding:10px">
          <label class="form-label">{{ $t('login.enter_phone') }}</label>
          <base-input
            v-model.trim="registerData.phone"
            :placeholder="$t('login.enter_phone')"
            type="text"
            name="phone"
          />
        </div>
      </div>

      <div class="row" style="padding:10px">
        <label class="form-label">{{ $t('login.enter_email') }}</label><span class="text-danger"> *</span>
        <base-input
          :invalid="$v.registerData.email.$error"
          v-model.trim="registerData.email"
          :placeholder="$t('login.enter_email')"
          type="email"
          name="email"
          @input="$v.registerData.email.$touch()"
        />
        <div v-if="$v.registerData.email.$error">
          <span v-if="!$v.registerData.email.required" class="text-danger">{{ $tc('validation.required') }}</span>
          <span v-if="!$v.registerData.email.email" class="text-danger">{{ $tc('validation.email_incorrect') }}</span>
        </div>
      </div>

      <div class="row" style="padding:10px">
          <p class="input-label">{{ $t('login.enter_password') }} <span class="text-danger"> * </span></p>
          <base-input
            v-model="registerData.password"
            :invalid="$v.registerData.password.$error"
            type="password"
            :placeholder="$t('login.enter_password')"
            show-password
            @input="$v.registerData.password.$touch()"
          />
          <div v-if="$v.registerData.password.$error">
            <span v-if="!$v.registerData.password.required" class="text-danger">{{ $tc('validation.required') }}</span>
            <span v-if="!$v.registerData.password.minLength" class="text-danger"> {{ $tc('validation.password_min_length', $v.registerData.password.$params.minLength.min, {count: $v.registerData.password.$params.minLength.min}) }} </span>
          </div>
        </div>

        <div class="row" style="padding:10px">
          <label class="form-label">{{ $t('wizard.confirm_password') }}</label><span class="text-danger"> *</span>
          <base-input
            :invalid="$v.registerData.confirm_password.$error"
            v-model.trim="registerData.confirm_password"
            type="password"
            :placeholder="$t('wizard.confirm_password')"
            name="confirm_password"
            @input="$v.registerData.confirm_password.$touch()"
          />
          <div v-if="$v.registerData.confirm_password.$error">
            <span v-if="!$v.registerData.confirm_password.sameAsPassword" class="text-danger">{{ $tc('validation.password_incorrect') }}</span>
          </div>
        </div>
      <base-button :loading="isLoading"  type="submit" class="btn btn-login btn-full">{{ $t('login.register') }}</base-button>

      <div class="other-actions mb-4">
        <router-link to="/login">
          {{ $t('general.back_to_login') }}
        </router-link>
      </div>

    </form>
</template>
<script type="text/babel">
import { validationMixin } from 'vuelidate'
import SettingDropdown from '../components/SettingListBox.vue'
import { mapActions } from 'vuex'
const { required, email , minLength, requiredIf, sameAs} = require('vuelidate/lib/validators')
export default {
  components: {
    'setting-dropdown': SettingDropdown
  },

  data () {
    return {
      registerData: {
        country_id: '',
        name:'',
        company:'',
        website:'',
        phone:'',
        email: '',
        password: '',
        confirm_password:'',
      },
      countries: [],
      country: null,
      isLoading: false,
      currencies:[],

    }
  },
  validations: {
    registerData: {
      name:{
        required,
      },
      company:{
        required,
      },

      email:{
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirm_password: {
        required: requiredIf('isRequired'),
        sameAsPassword: sameAs('password')
      }
    }
  },

  computed: {
    isRequired () {
      if (this.registerData.password === null || this.registerData.password === undefined || this.registerData.password === '') {
        return false
      }
      return true
    }
  },

  methods: {
    ...mapActions('auth', [
      'register',
    ]),

    async validateBeforeSubmit (e) {
      this.$v.registerData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      this.isLoading = true
      this.register(this.registerData).then((res) => {
        if(res){
          window.toastr['success'](res.data.message)
          this.$router.push('verify-email')
        }
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })

    },

  }
}
</script>
